import { AxiosResponse } from "axios"
import $api from "../../../axios"
import { IAudience } from "../types/audience"

const api = `/sp/audience/`

export const getAudiences = async () => {
  const result = await $api.get<IAudience[], AxiosResponse<IAudience[]>>(`${api}getAudiences`)

  return result.data
}
